import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "src/environments/environment";
import {
  RegistrationPaginationHelperModel
} from "../../models/reservations/registration-pagination-helper.model";
import { GetReservationsByUserRequestModel } from "../../models/reservations/get-reservations-by-user-request.model";
import { ExportDataModel } from "../../models/reservations/export-data.model";
import { CustomPeriodModel } from "../../models/reservations/custom-period.model";

const RESERVATION_API = environment.apiURL + '/api/mng/Reservation/';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }
  //#endregion

  //#region Public Methods
  getReservationsByVenue(model: RegistrationPaginationHelperModel) {
    const params = new HttpParams({ fromObject: model });
    let url = RESERVATION_API + "getreservationsforvenue";
    return this._httpClient.get(url, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
        return response;
      }));
  }

  getPriorityReservationsByVenue(model: RegistrationPaginationHelperModel) {
    const params = new HttpParams({ fromObject: model });
    let url = RESERVATION_API + "getpriorityreservationsforvenue";
    return this._httpClient.get(url, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
      return response;
    }));
  }

  getPastReservationsByVenue(model: RegistrationPaginationHelperModel) {
    const params = new HttpParams({ fromObject: model });
    let url = RESERVATION_API + "getpastreservationsforvenue";
    return this._httpClient.get(url, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
      return response;
    }));
  }

  getReservationsCount(id: string) {
    let url = RESERVATION_API + 'getreservationscount?VenueId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  getReservationDetails(id: string) {
    let url = RESERVATION_API + 'getreservationdetails?reservationId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  approveOrDenyReservation(reservationId: string, approve: boolean, declinedComment?: string) {
    let url = RESERVATION_API + 'approveordeclinereservation';
    return this._httpService.httpPost(url, {reservationId, approve, declinedComment})
      .pipe(map(response => {
        return response;
      }));
  }

  getReservationsForUserEmail(model: GetReservationsByUserRequestModel) {
    let url = RESERVATION_API + 'getapprovedreservationforuseremail';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  exportExcelToEmail(model: ExportDataModel) {
    const params = new HttpParams({ fromObject: model });
    let url = RESERVATION_API + 'sendexcelreportforreservations';
    return this._httpClient.get(url, {
      headers: new HttpHeaders({}).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
      return response;
    }));
  }

  downloadExcelFile(model: ExportDataModel) {
    const params = new HttpParams({ fromObject: model });
    let url = RESERVATION_API + 'getexcelreportforreservations';
    return this._httpClient.get(url, {
      responseType: 'blob',
      headers: new HttpHeaders({}).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
      return response;
    }));
  }

  addNotAllowedPeriod(model: CustomPeriodModel) {
    let url = RESERVATION_API + 'addnotallowperiod';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteNotAllowedPeriod(param: { id: string }) {
    let url = RESERVATION_API + 'deletenotallowperiod';
    return this._httpService.httpPost(url, param)
      .pipe(map(response => {
        return response;
      }));
  }

  addToPriorityList(reservationId: string) {
    let url = RESERVATION_API + 'setreservationaspriority';
    return this._httpService.httpPost(url, {reservationId})
      .pipe(map(response => {
        return response;
      }));
  }

  reorderPriorityList(reservationId: string, newPriority: number) {
    let url = RESERVATION_API + 'movereservationinprioritylist';
    return this._httpService.httpPost(url, {reservationId, newPriority})
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
